import { type FunctionComponent, type ReactNode, useState } from 'react';

import { Checkbox } from '@dr.pogodin/react-utils';

import { BODY_AREAS } from 'utils';

import type { CheckboxGroupPropsT } from '../common';

import '../common.scss';

const BodyAreas: FunctionComponent<CheckboxGroupPropsT> = ({
  setSpecs,
  specs,
}) => {
  const [customBodyArea, setCustomBodyArea] = useState<string>('');

  const bodyAreaSet = new Set(specs.bodyAreas);
  const content: ReactNode[] = [];

  for (const area of BODY_AREAS) {
    const checked = bodyAreaSet.has(area);
    content.push(
      <Checkbox
        checked={checked}
        key={area}
        label={area}
        onChange={() => {
          setSpecs({
            ...specs,
            bodyAreas: checked
              ? specs.bodyAreas.filter((item) => item !== area)
              : [...specs.bodyAreas, area],
          });
        }}
      />,
    );
  }

  content.push(<div key="separator" styleName="separator" />);

  for (let i = 0; i < specs.customBodyAreas.length; ++i) {
    const bodyArea = specs.customBodyAreas[i];
    if (!bodyArea) throw Error('Missing body area');
    content.push(
      <Checkbox
        checked
        key={`custom/${i}/${bodyArea}`}
        label={bodyArea}
        onChange={() => {
          const customBodyAreas = [...specs.customBodyAreas];
          customBodyAreas.splice(i, 1);
          setSpecs({ ...specs, customBodyAreas });
        }}
      />,
    );
  }

  content.push(
    <input
      key="custom-body-area-input"
      onChange={(e) => {
        setCustomBodyArea(e.target.value);
      }}
      onKeyDown={(e) => {
        if (customBodyArea && (e.key === 'Enter' || e.key === 'Tab')) {
          if (!specs.customBodyAreas.includes(customBodyArea)) {
            setSpecs({
              ...specs,
              customBodyAreas: [...specs.customBodyAreas, customBodyArea],
            });
          }
          setCustomBodyArea('');
        }
      }}
      placeholder="Other"
      styleName="plainInput"
      value={customBodyArea}
    />,
  );

  return (
    <div styleName="checkboxGroup">
      <div styleName="checkboxGroupTitle">Body Areas</div>
      {content}
    </div>
  );
};

export default BodyAreas;
